<fb-page-header [title]="'CAMPAIGNS' | translate" [subtitle]="'CAMPAIGNS_SUBTITLE' | translate">
    <button actions pButton type="button" severity="success" [loading]="creating()" (click)="newCampaign()">
        <i class="ph ph-plus"></i>
        <span>{{ 'NEW_CAMPAIGN' | translate }}</span>
    </button>
</fb-page-header>

<section class="rounded-md bg-surface border border-border overflow-hidden">
    <div class="flex flex-wrap items-center justify-between gap-3 p-4 border-b border-border">
        <p-iconfield class="w-full max-w-sm">
            <p-inputicon class="ph ph-magnifying-glass" />
            <input
                pInputText
                type="search"
                class="w-full"
                [placeholder]="'SEARCH_CAMPAIGNS' | translate"
                [ngModel]="search()"
                (ngModelChange)="search.set($event)" />
        </p-iconfield>
        @if (removedCount() > 0) {
            <label class="flex items-center gap-2 text-sm text-text-2 cursor-pointer">
                <p-toggleswitch [ngModel]="showRemoved()" (ngModelChange)="showRemoved.set($event)" />
                {{ 'SHOW_REMOVED' | translate }} ({{ removedCount() }})
            </label>
        }
    </div>

    <p-table [value]="visible()" [loading]="loading()" [paginator]="visible().length > 15" [rows]="15" [rowHover]="true" dataKey="id">
        <ng-template #header>
            <tr>
                <th>{{ 'NAME' | translate }}</th>
                <th>{{ 'STATUS' | translate }}</th>
                <th pSortableColumn="timing.dispatchDate">{{ 'DISPATCH_DATE' | translate }} <p-sort-icon field="timing.dispatchDate" /></th>
                <th class="text-right">{{ 'AUDIENCE' | translate }}</th>
                <th class="text-right">{{ 'EMAILS_SENT' | translate }}</th>
                <th class="text-right">{{ 'EMAILS_OPENED' | translate }}</th>
                <th class="text-right">{{ 'EMAILS_CLICKED' | translate }}</th>
                <th class="w-12"></th>
            </tr>
        </ng-template>

        <ng-template #body let-campaign>
            @let sent = campaign.status === 'DISPATCHED' && campaign.results?.email;
            <tr class="cursor-pointer" [class.opacity-60]="campaign.disabled" (click)="openDispatch(campaign.id)">
                <td class="min-w-52">
                    <div class="flex items-center gap-2">
                        <span class="font-medium text-text">{{ campaign.name }}</span>
                        @if (campaign.disabled) {
                            <p-tag [value]="'REMOVED' | translate" severity="secondary" />
                        }
                    </div>
                </td>
                <td class="whitespace-nowrap">
                    <p-tag
                        [value]="'DISPATCH_CAMPAIGN_STATUS_' + campaign.status | translate"
                        [severity]="
                            campaign.status === 'DISPATCHED'
                                ? 'success'
                                : campaign.status === 'READY_FOR_DISPATCH'
                                  ? campaign.isArmed
                                      ? 'info'
                                      : 'warn'
                                  : campaign.status === 'ERROR'
                                    ? 'danger'
                                    : 'secondary'
                        " />
                </td>
                <td class="whitespace-nowrap">
                    <span class="block text-sm text-text">{{ campaign.timing?.dispatchDate | date: 'mediumDate' }}</span>
                    <span class="block text-xs text-text-muted">{{ campaign.timing?.dispatchDate | date: 'HH:mm' }}</span>
                </td>
                <td class="text-right tabular-nums text-sm text-text-2">
                    {{ campaign.targetFilter?.preliminaryAudienceSize ? utility.numberFormat(campaign.targetFilter.preliminaryAudienceSize) : '–' }}
                </td>
                <td class="text-right tabular-nums text-sm text-text-2">
                    @if (sent) {
                        {{ utility.numberFormat(campaign.results.email.sent) }}
                        @if (campaign.results?.sms) {
                            <span class="block text-xs text-text-muted">SMS {{ utility.numberFormat(campaign.results.sms.sent) }}</span>
                        }
                    } @else {
                        <span class="text-text-muted">–</span>
                    }
                </td>
                <td class="text-right tabular-nums text-sm text-text-2">
                    {{ sent ? utility.numberFormat(campaign.results.email.opened) : '–' }}
                </td>
                <td class="text-right tabular-nums text-sm text-text-2">
                    {{ sent ? utility.numberFormat(campaign.results.email.clicked) : '–' }}
                </td>
                <td class="text-right" (click)="$event.stopPropagation()">
                    <button
                        pButton
                        type="button"
                        size="small"
                        [text]="true"
                        severity="secondary"
                        [attr.aria-label]="'ACTIONS' | translate"
                        (click)="rowMenuRef.toggle($event)">
                        <i class="ph ph-dots-three-vertical text-lg"></i>
                    </button>
                    <p-menu #rowMenuRef [model]="rowMenu(campaign)" [popup]="true" appendTo="body" />
                </td>
            </tr>
        </ng-template>

        <ng-template #emptymessage>
            <tr>
                <td colspan="8">
                    <fb-empty-state
                        icon="ph-megaphone"
                        [title]="(search() ? 'NO_CAMPAIGNS_MATCH' : 'NO_CAMPAIGNS_YET') | translate"
                        [text]="(search() ? '' : 'NO_CAMPAIGNS_YET_TEXT') | translate">
                        @if (!search()) {
                            <button pButton type="button" severity="success" [outlined]="true" [loading]="creating()" (click)="newCampaign()">
                                <i class="ph ph-plus"></i>
                                <span>{{ 'NEW_CAMPAIGN' | translate }}</span>
                            </button>
                        }
                    </fb-empty-state>
                </td>
            </tr>
        </ng-template>
    </p-table>
</section>
